import {
  MenuItem,
  Select,
  FormControl,
  OutlinedInput,
  InputLabel,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ListItem from "./ListItem";

const InventorySearch = ({
  categoryValue = "",
  searchValue = "",
  results,
  handleResultClick,
  handleSearch,
  handleSelect,
  handleClick,
}) => {
  // const parseResultsObjects = resArr => {
  //   const hasDescription = obj => Object.hasOwn(obj, "description")
  //   resArr.map(res => hasDescription(res) ? res : )
  // }
  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          margin: "0 0 0 0",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            // height: "35px",
            flex: 9,
            // border: `1px solid`,
            // borderColor: theme.palette.primary.main,
            borderRadius: "5px",
          }}
        >
          <FormControl
            variant="outlined"
            sx={{ width: "100%", height: "100%" }}
          >
            <OutlinedInput
              placeholder="Search Inventory"
              sx={{
                marginLeft: "8px",
                // boxShadow: "none",
                // ".MuiOutlinedInput-notchedOutline": { border: 0 },
              }}
              inputProps={{
                style: {
                  height: "100%",
                },
              }}
              endAdornment={<SearchIcon />}
              value={searchValue}
              onChange={handleSearch}
            />
          </FormControl>
        </div>
      </div>
      {results.length > 0 && (
        <div
          style={{
            // border: "1px solid black",
            maxHeight: "200px",
            margin: "0 10px 0 10px",
            overflowY: "scroll",
            borderRadius: "5px",
          }}
        >
          {results.map((res, i) => (
            <ListItem
              title={`${
                res.description ||
                res.item_description ||
                res.item ||
                res.job_name
              } ${res.internal_code ? ` (${res.internal_code})` : ""}`}
              onClick={() => {
                console.log(res);
                handleResultClick(res);
              }}
            />
          ))}
        </div>
      )}
    </>
  );
};
export default InventorySearch;
/* 
Inventory: description
Committed: item_description
Boneyard: item
*/
